import { MessageCircle } from "lucide-react";
import { CONTATO } from "../data/chales";

export default function FloatingWhatsApp() {
  return (
    <a
      href={`https://wa.me/${CONTATO.whatsapp}?text=${encodeURIComponent(
        "Olá! Gostaria de informações sobre os chalés do Laguna Alto Viçosa."
      )}`}
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105"
      data-testid="floating-whatsapp"
    >
      <MessageCircle className="h-7 w-7" />
    </a>
  );
}
